<script setup lang="ts">
// PROPS
interface Props {
    expiresAt: string;
}

const { expiresAt } = defineProps<Props>();

const { totalSeconds, countdownLabel, timeDatetimeAttribute } = useCountdown(toRef(() => expiresAt));
</script>

<template>
    <time v-if="totalSeconds > 0" :datetime="timeDatetimeAttribute">{{ countdownLabel }}</time>
</template>
